import PageHeader from './PageHeader';
import { HeaderTitle } from './HeaderTitle';
import { HeaderActions } from './HeaderActions';
import { PAGE_HEADER_VARIANTS } from './constants';
import { PageHeaderProps } from './types';

export type { PageHeaderProps } from './types';
export { PageHeader, HeaderActions, HeaderTitle };
export { StickyPageHeader } from './StickyPageHeader';

export const SecondaryPageHeader = (props: PageHeaderProps) => (
  <PageHeader variant={PAGE_HEADER_VARIANTS.SECONDARY} {...props} />
);
